 import { get_token } from "@/router";

const PROFILE_DETAIL_FIELDS = [
  "base_profile_id",
  "organization_name",
  "type_of_organization_id",
  "description",
  "email",
  "tell_number",
  "location",
  "street_address",
  "suburb",
  "town",
  "province",
  "postal_code",
  "country",
  "primary_color",
  "secondary_color",
  "tertiary_color",
  "is_private",
];

const PROFILE_DETAIL_PAYLOAD_KEYS = {
  organization_name: "company_name",
};

function append_profile_detail_fields(form_data, details) {
  PROFILE_DETAIL_FIELDS.forEach((field) => {
    form_data.append(
      Reflect.get(PROFILE_DETAIL_PAYLOAD_KEYS, field) || field,
      Reflect.get(details, field) ?? ""
    );
  });
}

function append_optional_coordinate(form_data, key, value) {
  if (value !== null && value !== undefined) {
    form_data.append(key, value);
  }
}

function create_profile_details_form_data(details) {
  const form_data = new FormData();
  append_profile_detail_fields(form_data, details);
  append_optional_coordinate(form_data, "latitude", details.latitude);
  append_optional_coordinate(form_data, "longitude", details.longitude);
  return form_data;
}

function handle_profile_update_success(response, resolve, reject) {
  if (response?.status && response.status !== "success") {
    reject(new Error(response?.message || "Organisation profile update failed."));
    return;
  }

  resolve(response);
}

function get_profile_update_error(xhr) {
  return new Error(
    xhr?.responseJSON?.message ||
    xhr?.statusText ||
    "Organisation profile update failed."
  );
}

export function update_company_profile_details(details) {
  return new Promise((resolve, reject) => {
    if (!details.base_profile_id) {
      reject(new Error("Profile id is missing. Cannot update organisation profile."));
      return;
    }

    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/update_user_company/`,
      type: "POST",
      headers: {
        Authorization: `Token ${get_token()}`,
      },
      data: create_profile_details_form_data(details),
      processData: false,
      contentType: false,
      success: (response) => handle_profile_update_success(response, resolve, reject),
      error: (xhr) => reject(get_profile_update_error(xhr)),
    });
  });
}
